export const TOGGLE_VIEW = {
  PREPARE: 'PREPARE',
  LAUNCH: 'LAUNCH',
  MONITOR: 'MONITOR',
  TIER_2: 'TIER_2',
}
